import { render } from "./ExtensionKeyAllocation.vue?vue&type=template&id=47cc453a&scoped=true"
import script from "./ExtensionKeyAllocation.vue?vue&type=script&lang=js"
export * from "./ExtensionKeyAllocation.vue?vue&type=script&lang=js"

import "./ExtensionKeyAllocation.vue?vue&type=style&index=0&id=47cc453a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cc453a"]])

export default __exports__